/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppDataRes } from '../../models/app-data-res';

export interface ApiAppDataGet$Params {
}

export function apiAppDataGet(http: HttpClient, rootUrl: string, params?: ApiAppDataGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AppDataRes>> {
  const rb = new RequestBuilder(rootUrl, apiAppDataGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppDataRes>;
    })
  );
}

apiAppDataGet.PATH = '/api/app/data';
